import { render, staticRenderFns } from "./IconWithText.vue?vue&type=template&id=98a42d1c"
import script from "./IconWithText.vue?vue&type=script&lang=js"
export * from "./IconWithText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports